import { Link } from 'react-router-dom'
import { CordMark } from '../ui/Cord'

export default function NoEncontrado() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-6 px-6 text-center">
      <CordMark className="h-4 w-9 text-laton" />
      <div>
        <h1 className="font-display text-3xl text-tinta">Esta página no existe</h1>
        <p className="mt-2 max-w-sm text-sm text-palo-hondo">
          Revisa el link que te compartieron. Si es el de una boda, debería verse como
          <span className="font-mono"> /b/nombre-y-nombre</span>.
        </p>
      </div>
      <Link
        to="/"
        className="rounded-md border border-palo px-4 py-2.5 text-sm text-tinta transition-colors hover:bg-palo/30"
      >
        Ir al inicio
      </Link>
    </main>
  )
}
